<template>
    <div class="datepicker-container" v-bind="schema.attributes">
        <date-picker ref="datepicker" v-model="value" v-bind="{ ...schema }" lang="fr" format="DD-MM-YYYY" title-format="DD-MM-YYYY" value-type="YYYY-MM-DD"></date-picker>
    </div>
</template>

<script>
    import DatePicker from "vue2-datepicker";
    import "vue2-datepicker/locale/fr";
    // DatePicker.props.lang.default = "fr";
    // DatePicker.props.format.default = "DD-MM-YYYY";
    // DatePicker.props.titleFormat.default = "DD-MM-YYYY";
    // DatePicker.props.valueType.default = "YYYY-MM-DD";

    import { abstractField } from "vue-form-generator";

    export default {
        mixins: [abstractField],
        components: {
            DatePicker
        },
        watch: {
            value() {
                this.$refs.datepicker.closePopup();
            }
        }
    };
</script>

<style lang="scss">
    .datepicker-container {
        width: 100%;

        input {
            font-size: 13px;
        }
    }

    .mx-calendar-header {
        button {
            &:hover {
                color: $primary;
            }
        }
    }

    .mx-calendar-content {
        .cell {
            &.today {
                color: $primary !important;
            }

            &.in-range {
                color: $primary !important;
                background-color: rgba($primary, 0.2) !important;
            }

            &.active {
                background-color: $primary !important;
            }

            &:hover {
                color: $primary !important;
                background-color: rgba($primary, 0.065) !important;
            }
        }
    }
</style>
